import { css } from "@emotion/react";

import { colors } from "@dotnet/telematics-design-system";

import { LabelComponentProps } from "./types";

const LabelComponent = ({
    title,
    isDisabled,
    hasInfo
}: LabelComponentProps) => {
    const { gray900, textDisabled } = colors;

    return (
        <span
            css={css({
                color: isDisabled ? textDisabled : gray900,
                fontSize: "14px",
                fontWeight: "500",
                lineHeight: "20px",
                letterSpacing: "0.1px",
                marginTop: "2px",
                marginBottom: hasInfo ? "0" : "2px"
            })}
        >
            {title}
        </span>
    );
};

export { LabelComponent };
